export default function About() {
  return (
    <div className="container page-animate pb-5" style={{ paddingTop: "140px" }}>
      <div className="row justify-content-center mb-5">
        <div className="col-lg-7">
          <div className="font-mono text-muted mb-3">SYSTEM ARCHITECTURE</div>
          <h1 className="display-5 fw-bold mb-4">Engineering the Edge</h1>
          <p className="lead text-muted mb-5">
            Traditional security extensions are bound by browser limitations. TapSecureX pushes the security perimeter out to the network interface.
          </p>
          
          <div className="border-start border-secondary ms-3 ps-4 ps-md-5 position-relative">
            {/* Step 1 */}
            <div className="mb-5 position-relative">
              <span className="position-absolute bg-white rounded-circle" style={{ width: "12px", height: "12px", left: "-42px", top: "8px", border: "3px solid #000" }}></span>
              <h4 className="mb-3 text-white">Native Loopback Routing</h4>
              <p className="text-muted">
                Leveraging Android's <code>Vpn Service</code> class, TapSecureX establishes a zero-hop local interface. It forces all DNS queries originating from the device—across all apps—into an isolated inspection tunnel before they can resolve an IP address.
              </p>
            </div>

            {/* Step 2 */}
            <div className="mb-5 position-relative">
              <span className="position-absolute bg-white rounded-circle" style={{ width: "12px", height: "12px", left: "-42px", top: "8px", border: "3px solid #000" }}></span>
              <h4 className="mb-3 text-white">Deterministic Filtering Matrix</h4>
              <p className="text-muted mb-2">
                Intercepted traffic enters the <code>Filter</code> class, which evaluates strings against optimized, locally stored trie-structures.
              </p>
              <p className="text-muted">
                If a malicious payload or tracker domain is detected, the engine instantly returns a sinkhole IP, neutralizing the connection at the protocol level.
              </p>
            </div>

            {/* Step 3 */}
            <div className="position-relative">
              <span className="position-absolute bg-white rounded-circle" style={{ width: "12px", height: "12px", left: "-42px", top: "8px", border: "3px solid #000" }}></span>
              <h4 className="mb-3 text-white">Asynchronous Intelligence</h4>
              <p className="text-muted mb-0">
                To guarantee zero-day resilience, TapSecureX polls the SentinelX backend for updated threat signatures. Crucially, the client pulls rules down; it never pushes user activity up.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}